import { useFetcher, useLoaderData } from '@remix-run/react'
import { formatDateTime } from '~/design-system/helpers/misc'
import { Card, CardContainer } from '~/design-system/primitives'
import { ActionEdit, Delete, DeployedCodeUpdate, Storefront } from '~/icons'
import type { loader } from '~/routes/checkout.cart'

type Props = {
  openShippingScheduleModal: () => void
}

export const PickupSelectedCard = ({ openShippingScheduleModal }: Props) => {
  const { selectedSlaPickup } = useLoaderData<typeof loader>()
  const { selectedPickupHour, pickupInPointSelected } = JSON.parse(selectedSlaPickup.postalCodeDayAndHour)
  const deliveryHourFormatted = formatDateTime(selectedSlaPickup.startDateUtc, selectedSlaPickup.endDateUtc)
  const formattedDate =
    `${deliveryHourFormatted.day}/${deliveryHourFormatted.month}/${deliveryHourFormatted.year}` as string

  const fetcher = useFetcher()

  return (
    <Card className="bg-[#FAF9F9]" color="primary" size="full">
      <div className="flex gap-4 w-full">
        <CardContainer className="flex flex-col">
          <div>
            <div className="flex gap-3">
              <DeployedCodeUpdate className="fill-gray-100 h-[18px] w-[18px]" />
              <p className="text-sm font-medium">{pickupInPointSelected.pickupStoreInfo.friendlyName}</p>
            </div>
            <div className="w-full pl-[30px]">
              <p className="pt-2">
                Retire no dia {<span className={`text-sm text-primary-orange`}>{formattedDate}</span>} das{' '}
                {<span className={`text-sm text-primary-orange`}>{selectedPickupHour['startDateUtc']}</span>}{' '}
                às {<span className={`text-sm text-primary-orange`}>{selectedPickupHour['endDateUtc']}</span>}
              </p>
            </div>
          </div>
          <div className="flex flex-col mt-2 w-full">
            <div className="flex">
              <Storefront className="fill-gray-100 h-[18px] w-[18px]" />
              <div className="flex flex-col ml-3">
                <p className="text-sm font-medium">
                  {pickupInPointSelected.pickupStoreInfo.friendlyName.split('-').at(1).trim()}
                </p>
                <p className="text-sm pt-2">
                  {pickupInPointSelected.pickupStoreInfo.address.street}{' '}
                  {pickupInPointSelected.pickupStoreInfo.address.number}{' '}
                  {pickupInPointSelected.pickupStoreInfo.address.neighborhood}
                </p>
              </div>
            </div>
          </div>
        </CardContainer>

        <div className="flex flex-col gap-4">
          <button className="flex" onClick={openShippingScheduleModal}>
            <ActionEdit className="h-[18px] w-[18px] fill-gray-40" />
          </button>
          <fetcher.Form action="/checkout/cart" method="post">
            <button className="flex" name="actionType" type="submit" value="deleteDeliveryOption">
              <Delete className="h-[18px] w-[18px] fill-gray-40" />
            </button>
          </fetcher.Form>
        </div>
      </div>
    </Card>
  )
}

export default PickupSelectedCard
